import React from 'react';

export default ({ fillColor }) => (
  <svg width="1734.421" height="1558.307" viewBox="0 0 1734.421 1558.307">
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1785"
          data-name="Rectangle 1785"
          width="1734.421"
          height="1558.307"
          fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
          stroke="#707070"
          strokeWidth="1"
        />
      </clipPath>
    </defs>
    <g id="end-survey-background" clipPath="url(#clip-path)">
      <g id="blue-blob-2" transform="translate(-1164.153 -244.629)">
        <path
          id="Path_7604"
          data-name="Path 7604"
          d="M292.05,1021.138C492.814,1270,796.241,1361.878,920.36,1339.018c431.835-79.771,534.047-535.362,824.61-518.475C1906.6,829.937,2816.663,954.776,3049.661,972.68s622.015-127.3,849.637-308.385c284.283-197.944,226.429-367.93-6-523.774a71.686,71.686,0,0,0-21.73-10.033C3796.132,111.044,3342.39-1.738,2956.3.02c-422.4,1.989-689.374,172.013-1098.073,183.568S907.927,13.572,637.447,33.161C488.439,43.83,389.566,57.689,331.009,67.831,267.2,78.509,205.49,106.725,147.91,151.543-81.7,331.728-51.659,635.453,292.05,1021.138Z"
          transform="matrix(-0.998, -0.07, 0.07, -0.998, 4080.834, 1624.483)"
          fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
        />
        <path
          id="Path_7605"
          data-name="Path 7605"
          d="M9.046.731c27.676,22.9,57.629,40.138,89.41,51.45a254.535,254.535,0,0,0,27.5,8.117c6.246,1.468,1.446,19.191-4.817,17.691A288.486,288.486,0,0,1,26.021,35.345Q13.684,26.892,1.851,17.123C-3.416,12.752,3.7-3.659,8.983.743Z"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 1056.656, 1332.748)"
          fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
        />
        <path
          id="Path_7606"
          data-name="Path 7606"
          d="M7.535.213c22.67,8.763,46.089,16.232,70.518,18.431,2.63.777,3.692,5.318,2.382,10.186-1.374,4.819-4.543,8.123-7.2,7.505C48.794,34.243,25.409,26.663,2.718,17.9-3.184,15.6,1.495-2.13,7.535.213Z"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 1220.105, 1360.861)"
          fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
        />
        <path
          id="Path_7607"
          data-name="Path 7607"
          d="M6.258.072C13.02-1.27,10.95,16.5,4.167,17.848S-.546,1.423,6.258.072Z"
          transform="matrix(0.966, -0.259, 0.259, 0.966, 1203.289, 1361.11)"
          fill={`${fillColor ? `${fillColor}40` : '#f5f2fe'}`}
        />
      </g>
    </g>
  </svg>
);
